<template>
    <address id="contact" class="contact-component page-section">
        <div class="container">
            <header class="main-title title">Contact me</header>
            <div class="contact-layout">
                <div class="contact-info-container">
                    <ul class="contact-list">
                        <li>
                            <a class="contact-row" href="mailto:goralexcontact@gmail.com">
                                <span class="icon-container">
                                    <font-awesome-icon class="icon" :icon="['fas', 'envelope']"/>
                                </span>
                                <span class="text">
                                    <span class="label">Email</span>
                                    <span class="value">goralexcontact@gmail.com</span>
                                </span>
                            </a>
                        </li>
                        <li>
                            <a class="contact-row" href="tel:+9720547980108">
                                <span class="icon-container">
                                    <font-awesome-icon class="icon" :icon="['fas', 'phone']"/>
                                </span>
                                <span class="text">
                                    <span class="label">Phone</span>
                                    <span class="value">(+972) 054-7980108</span>
                                </span>
                            </a>
                        </li>
                        <li>
                            <div class="contact-row">
                                <span class="icon-container">
                                    <font-awesome-icon class="icon" :icon="['fas', 'map-marker-alt']"/>
                                </span>
                                <span class="text">
                                    <span class="label">Location</span>
                                    <span class="value">Rishon LeTsiyon, Israel</span>
                                </span>
                            </div>
                        </li>
                    </ul>
                    <div class="social-networks">
                        <a class="social-link" href="https://www.linkedin.com/in/goralex" target="_blank"
                           rel="noopener" aria-label="LinkedIn">
                            <span class="icon-container">
                                <font-awesome-icon class="icon" :icon="['fab', 'linkedin-in']"/>
                            </span>
                        </a>
                        <a class="social-link" href="https://github.com/Rishon1983" target="_blank"
                           rel="noopener" aria-label="GitHub">
                            <span class="icon-container">
                                <font-awesome-icon class="icon" :icon="['fab', 'github']"/>
                            </span>
                        </a>
                    </div>
                </div>
                <div class="map-container">
                    <iframe width="100%" height="400px" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
                            src="https://maps.google.com/maps?hl=en&amp;ie=UTF8&amp;ll=31.9654205,34.659786&amp;t=m&amp;z=10&amp;output=embed&q=Rishon LeTsiyon, Israel&zoom=10"></iframe>
                </div>
            </div>
            <div class="form-mail-container">
                <div class="form-body">
                    <div class="mail-container">
                        <input id="contact-name" type="text" placeholder="Your Name *" v-model="mailForm.name">
                        <input id="contact-email" type="email" placeholder="Your Email *" :class="['', isEmailValid()]"
                               v-model="mailForm.email">
                    </div>
                    <div class="mail-container">
                    <textarea id="contact-msg" v-model="mailForm.message"
                              placeholder="Your Message *" maxlength="999"
                              style="resize:none"></textarea>
                    </div>
                </div>
                <button class="form-button">Send Message</button>
            </div>
        </div>
    </address>
</template>

<script>
    export default {
        name: "ContactComponent",
        data() {
            return {
                mailForm: {
                    name: '',
                    email: '',
                    message: ''
                },
            };
        },
        methods: {
            isEmailValid() {
                let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return (this.mailForm.email === '') ? "" : (reg.test(this.mailForm.email)) ? 'has-success' : 'has-error';
            },
        }
    }
</script>

<style lang="scss" scoped>
    #contact.contact-component {
        .container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .main-title {
                margin-bottom: var(--section-title-gap, 50px);
            }

            .contact-layout {
                display: grid;
                grid-template-columns: minmax(0, 380px) minmax(0, 1fr);
                gap: 40px;
                align-items: stretch;
                width: 100%;
                max-width: 1100px;
                margin-bottom: 40px;

                .contact-info-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    gap: 28px;

                    .contact-list {
                        margin: 0;
                        padding: 0;
                        list-style: none;
                        border-top: 2px solid #e9ecef;

                        li {
                            border-bottom: 2px solid #e9ecef;
                        }

                        .contact-row {
                            display: flex;
                            align-items: center;
                            gap: 16px;
                            padding: 16px 0;
                            color: #2c3e50;
                            text-decoration: none;

                            .text {
                                display: flex;
                                flex-direction: column;
                                min-width: 0;

                                .label {
                                    font-size: 0.85em;
                                    color: #979a9c;
                                }

                                .value {
                                    font-weight: bold;
                                    overflow-wrap: anywhere;
                                }
                            }
                        }

                        a.contact-row:hover, a.contact-row:focus-visible {
                            outline: none;

                            .icon-container {
                                background-color: #1CB8B6;
                            }
                        }
                    }

                    .icon-container {
                        flex: none;
                        width: 50px;
                        height: 50px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #ffffff;
                        background-color: #2c3e50;
                        border-radius: 50%;
                        transition: background-color .3s ease;

                        svg {
                            height: 22px;
                            width: 22px;
                        }
                    }

                    .social-networks {
                        display: flex;
                        gap: 12px;

                        .social-link {
                            border-radius: 50%;

                            &:hover, &:focus-visible {
                                outline: none;

                                .icon-container {
                                    background-color: #1CB8B6;
                                }
                            }
                        }
                    }
                }

                .map-container {
                    min-height: 360px;
                    overflow: hidden;
                    border: 2px solid #e9ecef;
                    border-radius: 12px;

                    iframe {
                        display: block;
                        width: 100%;
                        height: 100%;
                        min-height: 360px;
                        border: 0;
                    }
                }
            }

            .form-mail-container {
                display: none;
                width: 60%;
                /*display: flex;*/
                justify-content: center;
                align-items: center;
                flex-direction: column;
                margin: 0 0 40px 0;

                .form-body {
                    width: 100%;
                    display: flex;

                    .mail-container {
                        width: 50%;
                        height: 150px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;

                        input, textarea {
                            padding: 20px;
                            border: 1px solid #ced4da;
                            border-radius: .25em;
                            font-size: 1em;
                            font-weight: bold;
                            line-height: 1.5;

                            &:focus {
                                border-color: #2c3e50;
                                outline: 0;
                                box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(44, 62, 80, .6);
                            }

                            &.has-error {
                                border-color: #a94442;
                                box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
                            }
                        }

                        input {
                            margin: 0 10px 0 0;
                        }

                        textarea {
                            font-family: Roboto, Arial, sans-serif;
                            margin: 0 0 0 10px;
                            height: 100%;
                            font-size: 1em;
                            font-weight: bold;
                            line-height: 1.5;
                        }
                    }
                }

                .form-button {
                    height: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #2c3e50;
                    color: #ffffff;
                    border-radius: .25em;
                    font-size: 1em;
                    font-weight: bold;
                    margin: 20px;
                    padding: 0 15px;
                    border: 0;

                    &:focus {
                        outline: none;
                    }

                    &:hover {
                        background-color: #1CB8B6;
                        //background-color: #2f5ad6;
                        transition: all ease .5s;
                        cursor: pointer;
                    }
                }

            }
        }
    }

    /*media*/
    @media screen and (max-width: 900px) {
        #contact.contact-component {
            .container {
                .contact-layout {
                    grid-template-columns: minmax(0, 1fr);
                    gap: 28px;

                    .map-container {
                        min-height: 300px;

                        iframe {
                            min-height: 300px;
                        }
                    }
                }
            }
        }
    }
</style>
